jQuery(function ($) {
    var $doc = $(window.document),
        $win = $(window),
        winWidth = $win.width();

    function slider_arrows_near_dots($slider, $position) {
        var $bulletWidth = 8,
            $count = 0,
            $helper = 55,
            $prev = $slider.find('.swiper-button-prev'),
            $next = $slider.find('.swiper-button-next');

        $slider.find('.swiper-pagination span').each(function () {
            $count++;
        });

        if ($count === 0) {
            $count = 1;
        } else if ($count > 30) {
            $helper = 0;
        }

        var $gap = parseInt($bulletWidth) * parseInt($count) + $helper;

        $prev.css('left', 'calc( ' + $position + '% - ' + $gap + 'px');
        $next.css('right', 'calc( ' + $position + '% - ' + $gap + 'px');
    }

    /**
     * Make product sidebar sticky or not by compare height image area vs sidebar
     */

    function product_sticky_sidabar() {
        // Added sticky to product page
        var $wrapper = $('.product-sticky-sidebar'),
            $sticky = $wrapper.find('.product-sidebar-inner'),
            $images = $('.main-product-carousel');

        if ($images.height() <= $sticky.outerHeight()) {
            $wrapper.removeClass('Product__InfoWrapper');
            $wrapper.removeClass('md:pl-12');
            $sticky.removeClass('Product__Info');
        } else {
            $wrapper.addClass('Product__InfoWrapper');
            $wrapper.addClass('md:pl-12');
            $sticky.addClass('Product__Info');
        }
    }

    /**
     * Switch main product accordion works via js
     */
    // function change_input_active_tab_class() {
    //     $label.each(function () {
    //         var $this = $(this),
    //             $tab = $this.parent();

    //         if ($tab.hasClass('active')) {
    //             $tab.removeClass('active');
    //             $tab.addClass('was-active');
    //         }
    //     });
    // }

    var $productReview = new Swiper('.product-review-carousel', {
        slidesPerView: 2,
        spaceBetween: 30,
        speed: 400,
        // autoplayDisableOnInteraction: false,
        loop: true,
        autoplay: false,

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 12,
            },
            998: {
                slidesPerView: 2,
                spaceBetween: 33,
            },
        },
    });

    var $productMobile = undefined;

    function initSwiper() {
        winWidth = $win.width();

        if (winWidth <= 998 && $productMobile == undefined) {
            $productMobile = new Swiper('.main-product-carousel', {
                /*slidesPerView: 1,
        spaceBetween: 30,
        speed: 400,
        autoplayDisableOnInteraction: false,
        loop: true,
        autoplay: {
          delay: 8000
        },

        pagination: {
          el: '.main-product-carousel .swiper-pagination',
          clickable: true,
        }*/
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 400,
                observer: true,
                observeParents: true,
                watchOverflow: true,
                autoplayDisableOnInteraction: false,
                loop: false,
              autoHeight: true,
                autoplay: {
                    delay: 8000,
                },

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                },
                on : {
                slideChange: function () { 
                  /* do something */
                  // console.log('hhhhhh');
                  $('.Product--large .swiper-slide.swiper-slide-active').each(function(){
    
      setTimeout(function() {
        $('.Product--large .swiper-slide').removeClass('yes-selected');
      $('.Product--large .swiper-slide.swiper-slide-active').addClass('yes-selected');
        if($('.Product--large .swiper-slide.yes-selected').hasClass('youtube-video')){
          console.log('yes its video');
          $('.Product--large .swiper-slide.youtube-video .ytLink').trigger('click');
        }
      }, 500);
    
  });

                  
                  //  if($('.Product--large .swiper-slide.swiper-slide-active').find('iframe')){
                  //   console.log('find');
                  //   playPauseVideo($('.Product--large .swiper-slide.swiper-slide-active').find('iframe'),"play");
                  //  // var videoDataSrc = $('.swiper-slide.swiper-slide-active').find('iframe').attr('src');
                  //  //  console.log(videoDataSrc);
                  // // $('.new-product-kichana-item[data-slick-index="'+currentSlide+'"]').find('.vimeo-video').attr('src',videoDataSrc);
                  //   function playPauseVideo(slick, control){
                  //   var currentSlide, slideType, startTime, player, video;
                    
                  //   // currentSlide = slick.find(".slick-current");
                  //   // slideType = currentSlide.find('iframe').data('type');
                  //   player = slick.get(0);
                  //   //startTime = currentSlide.data("video-start");
                    
                    
                    
                  //   switch (control) {
                  //   case "play":
                  //   postMessageToPlayer(player, {
                  //   "event": "command",
                  //   "func": "mute"
                  //   });
                  //   postMessageToPlayer(player, {
                  //   "event": "command",
                  //   "func": "playVideo"
                  //   });
                  //   break;
                  //   case "pause":
                  //   postMessageToPlayer(player, {
                  //   "event": "command",
                  //   "func": "pauseVideo"
                  //   });
                  //   break;
                  //   }
                    
                  //   }
                  // // POST commands to YouTube or Vimeo API
                  // function postMessageToPlayer(player, command){
                  // console.log(command);
                  // if (player == null || command == null) return;
                  // player.contentWindow.postMessage(JSON.stringify(command), "*");
                  // }
                  // }
                 }
                },
            });
        } else if (winWidth > 998 && $productMobile != undefined) {
            setTimeout(function () {
                $productMobile.destroy();
                $productMobile = undefined;
                jQuery('.main-product-carousel').removeAttr('style');
                jQuery('.main-product-carousel .swiper-slide').removeAttr('style');
                jQuery('.main-product-carousel .swiper-pagination').addClass('md:hidden');
            }, 1000);
        }

       
    }

    if (winWidth <= 998) {
        //Swiper plugin initialization
        initSwiper();
      console.log('hh');
        var $productReviewSlider = $('.product-review-carousel');

        slider_arrows_near_dots($productReviewSlider, 50);

      
    }

    //Swiper plugin initialization on window resize
    $(window).on('resize', function () {
        initSwiper();

        winWidth = $win.width();

        if (winWidth <= 998) {
            var $productReviewSlider = $('.product-review-carousel');

            slider_arrows_near_dots($productReviewSlider, 50);
        }

        if (winWidth > 998) {
            setTimeout(function () {
                $('.product-new-template .swatch_option.color-swatch-option.active').click();
            }, 500);
        }
    });

    $('.tab label').on('click', function () {
        $hasClass = $(this).parent().hasClass('active');
        $('.tabs .tab').removeClass('active');
        if (!$hasClass) {
            $(this).parent().addClass('active');
        }
        product_sticky_sidabar();
    });

    // var $productCollaps = $('.product-collapse-list'),
    //     $collapsItem = $productCollaps.find('.collapse-title'),
    //     $label = $productCollaps.find('label');

    // $label.on('click', function () {
    //     var $this = $(this),
    //         $tab = $this.parent();

    //     $hasClass = $tab.hasClass('active');
    //     $tab.removeClass('active');

    //     if (!$hasClass) {
    //         $tab.addClass('active');
    //     }

        // change_input_active_tab_class();

        // if (!$tab.hasClass('active')) {
        //     $tab.addClass('active');
        // }

        // $tab.addClass('active');

        // if (!$tab.hasClass('was-active')) {
        //     $tab.addClass('active');
        // } else {
        //     $tab.removeClass('was-active');
        // }

        // $tab.addClass('active');

    //     product_sticky_sidabar();
    // });

    // $collapsItem.on('click', function () {
    //     var $this = $(this),
    //         $wrapper = $this.parents('.product-collapse-list'),
    //         $items = $wrapper.find('.item');

    //     $items.each(function () {
    //         var $this = $(this);

    //         if ($this.hasClass('active')) {
    //             $this.removeClass('active');
    //         }
    //     });

    //     $this.parent().parent().addClass('active');
    // });

    // Modal js
    var openmodal = document.querySelectorAll('.modal-open');
    for (var i = 0; i < openmodal.length; i++) {
        openmodal[i].addEventListener('click', function (event) {
            event.preventDefault();
            toggleModal();
        });
    }

    const overlay = document.querySelector('.modal-overlay');
    if( overlay !== null )
        overlay.addEventListener('click', toggleModal);

    var closemodal = document.querySelectorAll('.modal-close');
    for (var i = 0; i < closemodal.length; i++) {
        closemodal[i].addEventListener('click', toggleModal);
    }

    document.onkeydown = function (evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ('key' in evt) {
            isEscape = evt.key === 'Escape' || evt.key === 'Esc';
        } else {
            isEscape = evt.keyCode === 27;
        }
        if (isEscape && document.body.classList.contains('modal-active')) {
            toggleModal();
        }
    };

    function toggleModal() {
        const body = document.querySelector('body');
        const modal = document.querySelector('.modal');
        modal.classList.toggle('opacity-0');
        modal.classList.toggle('pointer-events-none');
        modal.classList.toggle('hidden');
        body.classList.toggle('modal-active');
    }

    var minVal = 1,
        maxVal = 20; // Set Max and Min values
    // Increase product quantity on cart page
    $('.increaseQty').on('click', function () {
        var $parentElm = $(this).siblings('.qtyValue');
        $(this).addClass('clicked');
        setTimeout(function () {
            $('.clicked').removeClass('clicked');
        }, 100);
        var value = $parentElm.val();
        if (value < maxVal) {
            value++;
        }
        $parentElm.val(value);
    });
    // Decrease product quantity on cart page
    $('.decreaseQty').on('click', function () {
        var $parentElm = $(this).siblings('.qtyValue');
        $(this).addClass('clicked');
        setTimeout(function () {
            $('.clicked').removeClass('clicked');
        }, 100);
        var value = $parentElm.val();
        if (value > 1) {
            value--;
        }
        $parentElm.val(value);
    });

    $('.product-buy-button').on('click', function () {
        var c_de = $(this).attr('data-code');
        $('input[name=return_to]').val(c_de);
    });

    setTimeout(function () {
        $('.product-new-template .swatch_option.color-swatch-option.active').click();
    }, 500);
    $('.product-new-template .swatch_option').on('click', function (event) {
        if ($(this).hasClass('disabled')) {
            return false;
        }

        $(this).closest('.product-new-template').find('.swatch_option').removeClass('active');
        $(this).addClass('active');
        if ($(this).hasClass('color-swatch-option')) {
            $('[data-option="size"]')
                .addClass('cursor-pointer')
                .removeClass('cursor-not-allowed')
                .removeClass('disabled');
            var indexPosition = $(this).attr('data-option-position');
            var thisColor = $('.product-new-template').find(
                '.swatch_option.active[data-option-position=' + indexPosition + ']'
            );
            var disabledOptions = $('[name=id] option').filter(function () {
                return (
                    $(this).attr('option' + indexPosition) == ($(thisColor).attr('data-value') ?? '') &&
                    $(this).attr('data-available') == 'false'
                );
            });
            if (disabledOptions != undefined && disabledOptions.length > 0) {
                var sizes = $(disabledOptions)
                    .map(function () {
                        return $(this).attr('option' + $('[data-option="size"]').attr('data-option-position'));
                    })
                    .get();
                if (sizes != undefined && sizes.length > 0) {
                    var sizesDisable = $('[data-option="size"]').filter(function () {
                        return sizes.indexOf($(this).attr('data-value')) > -1;
                    });
                    if (sizesDisable != undefined && sizesDisable.length > 0) {
                        $(sizesDisable).addClass('cursor-not-allowed').addClass('disabled');
                    }
                }
            }
            $('[data-option="size"]').removeClass('active');

            $('[data-option="size"]:not(.disabled):eq(0)').addClass('active');
            $('[data-option="size"].active').click();

            $('.main-product-carousel .swiper-slide').hide();
            $('.main-product-carousel .swiper-slide:has(img[alt=' + $(this).attr('data-value') + '])').show();

            //$productMobile = undefined;
            if (winWidth <= 998) {
                //&& $productMobile == undefined) {
                //$productMobile.destroy();
                $productMobile = undefined;
                initSwiper();
            }
        }

        if ($('.' + $(this).attr('data-target-label')).length > 0) {
            $('.' + $(this).attr('data-target-label')).text($(this).attr('data-display-value'));
        }
        var option1 = $('.product-new-template').find('.swatch_option.active[data-option-position=1]');
        var option2 = $('.product-new-template').find('.swatch_option.active[data-option-position=2]');
        var option3 = $('.product-new-template').find('.swatch_option.active[data-option-position=3]');
        var selectedVariant = $('[name=id] option').filter(function () {
            return (
                $(this).attr('option1') == ($(option1).attr('data-value') ?? '') &&
                $(this).attr('option2') == ($(option2).attr('data-value') ?? '') &&
                $(this).attr('option3') == ($(option3).attr('data-value') ?? '')
            );
        });
        if (selectedVariant != undefined && selectedVariant.length > 0) {
            $('[name=id]').val($(selectedVariant).val());
        }
    });

    product_sticky_sidabar();
});
